<template>
  <div>
    <!-- eslint-disable-next-line -->
    <div v-for="dialog in $store.state.Dialog.promptDialog">
      <v-dialog max-width="290" persistent v-model="dialog.isConfirm">
        <v-card>
          <v-card-title class="headline">{{ dialog.title }}</v-card-title>
          <v-card-text
            >{{ dialog.content }}<br />
            <v-form lazy-validation ref="promptForm" v-model="formValid">
              <v-text-field :label="dialog.label" :placeholder="dialog.placeholder" :rules="dialog.rules" v-if="!dialog.textarea" v-model="dialog.model">
              </v-text-field>
              <v-textarea
                :label="dialog.label"
                :placeholder="dialog.placeholder"
                :rules="dialog.rules"
                auto-grow
                rows="1"
                v-if="dialog.textarea"
                v-model="dialog.model"
              >
              </v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$store.commit('CANCEL_PROMPT', dialog)" color="" text>{{ $t("global.cancel") }}</v-btn>
            <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="clickOk(dialog)" color="accent" text>{{ $t("global.ok") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromptDialog",
  data: () => ({
    formValid: true
  }),
  methods: {
    clickOk(dialog) {
      if (this.$refs.promptForm[0].validate()) {
        this.$store.commit("ACCEPT_PROMPT", dialog);
      }
    }
  }
};
</script>

<style scoped></style>
